import { render } from "./wSearch.vue?vue&type=template&id=1efd7191&ts=true"
import script from "./wSearch.vue?vue&type=script&lang=ts"
export * from "./wSearch.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__